import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { mergeMap, of, take } from 'rxjs';
import { IDevice } from 'src/app/shared/models/IDevice';
import { IUserSession } from 'src/app/shared/models/IUserSession';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { Sort } from 'src/app/shared/util/sort';
import { UserSessionService } from '../users/shared/user-session.service';
import { DeviceService } from './shared/device.service';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css']
})
export class DevicesComponent implements OnInit {
  resourceKeyValue: any;
  isLoading: boolean = false;
  isDefaultSort = true;
  devices: IDevice[];
  devices2display: IDevice[];
  rowDevices: IDevice[];
  pageSizeOptions = [];
  pageSize = 25;
  pageSizeDisplay = 25;
  pageIndex = 1;
  numberOfPages = 0;
  totalNumber: number;
  directionColumnName: string = 'asc';
  sortableState = '1';
  isFacilityConfigured: boolean;
  lblNotAuthorizedInstruction1 = '';
  lblNotAuthorizedInstruction2 = '';
  searchDevicesForm = this.fb.group({
    term: [''],
  });
  @ViewChild("deviceTable", { read: ElementRef }) deviceTable: ElementRef;

  constructor(private deviceService: DeviceService,
    private resourcesService: ResourcesService,
    private userSessionService: UserSessionService,
    private fb: UntypedFormBuilder,
    private renderer: Renderer2,
    public toastrService: ToastrService) { }

  ngOnInit(): void {
    this.resourcesService.bsObject
      .subscribe((result: any) => {
        result && (this.resourceKeyValue = result);
        this.pageSizeOptions = [10, 25, 50, 100, { showAll: this.resourceKeyValue.showAll }];
        this.setControlValues();
        this.getDevices();
      });
  }
  getDevices(): void {
    this.isLoading = true;
    this.userSessionService.getUserSession().pipe(
      take(1),
      mergeMap((userSessionDetail: IUserSession) => {
        if (userSessionDetail?.facilityId) {
          this.isFacilityConfigured = true;
          return this.deviceService.getAllDevices(userSessionDetail.facilityId);
        } else {
          this.isFacilityConfigured = false;
          return of([]);
        }
      })
    ).subscribe((devicesData: IDevice[]) => {
      if (devicesData) {
        this.rowDevices = devicesData;
        this.devices = this.rowDevices;
        this.totalNumber = this.rowDevices.length;
        this.numberOfPages = Math.ceil(this.totalNumber / this.pageSize);
        //first ordering the records by name asc
        this.columnSort('deviceID', this.directionColumnName);
      }
      this.isLoading = false;
    },
      (error) => {
        if (error.code == 404) {
          this.devices = [];
          this.rowDevices = [];
          this.searchDevicesForm.controls['term'].disable();
          this.isLoading = false;
          return;
        }
      });
  }

  search(e: string) {
    this.isDefaultSort = true;
    this.devices = this.rowDevices;
    this.devices = this.devices.filter(x => this.matches(x, e));
    this.totalNumber = this.devices.length;
    this.refreshDevices();
    this.columnSort('deviceID', this.directionColumnName);
  }
  refreshDevices() {
    this.isDefaultSort = true;
    this.devices2display = this.devices
      .map((device, i) => ({ id: i + 1, ...device }))
      .slice((this.pageIndex - 1) * this.pageSize, (this.pageIndex - 1) * this.pageSize + this.pageSize);
    this.numberOfPages = Math.ceil(this.totalNumber / this.pageSize);

    if (this.deviceTable) {
      let elements: Element[] = this.deviceTable.nativeElement.getElementsByClassName('sorted-desc') || this.deviceTable.nativeElement.getElementsByClassName('sorted-asc');
      if (elements && elements.length) {
        Array.from(elements).forEach((element: any) => {
          this.renderer.removeClass(element, 'sorted-desc');
          this.renderer.removeClass(element, 'sorted-asc');

          if (element.getAttribute('data-order') && element.getAttribute('data-order') == 'asc') {
            element.setAttribute('data-order', 'desc');
          }
        });
      }

      let sortElement = this.deviceTable.nativeElement.getElementsByClassName('initialSort');
      if (sortElement && sortElement.length) {
        this.renderer.addClass(sortElement[0], 'sorted-asc');
      }
    }

    this.sortableState = '1';
    this.columnSort('name', this.directionColumnName);
  }

  columnSort(property: string, direction: string) {
    const dataSort = new Sort();
    this.devices.sort(dataSort.startSort(property, direction));
  }

  matches(device: IDevice, term: string) {
    return device.deviceID.toLowerCase().includes(term.toLocaleLowerCase());
  }

  isNumber(val): boolean { return typeof val === 'number'; }

  setControlValues(): void {
    this.lblNotAuthorizedInstruction1 = this.resourceKeyValue.lblNotAuthorizedInstruction3;
    this.lblNotAuthorizedInstruction2 = this.resourceKeyValue.lblNotAuthorizedInstruction4;
  }
}
